export function _sortByName(
  a: { name?: string | null } | null | undefined,
  b: { name?: string | null } | null | undefined,
): number {
  const an = (a || {}).name ?? '';
  const bn = (b || {}).name ?? '';
  return an.toLowerCase().localeCompare(bn.toLowerCase());
}
